module.exports = __webpack_public_path__ + "media/images/cloud-2-0035cdf3ce79b71523392df0e0b3d722.png";